module.exports = __webpack_public_path__ + "static/img/pintu.6ed4423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pintu.png
// module id = Guxc
// module chunks = 1